import React from 'react';
import { Select, Spin, Button, Icon, Modal, Form, Row, Col } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogosRequest from '../../services/Catalogos';
import CategoriasRequest from '../../services/Categorias';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;

/**
 * Clase para ver el proceso de formulario de categorizar
 */
class FormAsignacion extends BaseComponent {
    state = {
        arrCategorias: [],
        arrDiasSemana: [],
        cargando: false,
        bloquearBotones: false,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.tipo_modal !== prevProps.tipo_modal) {
            if (this.props.tipo_modal === 'uno') {
                if (!state.arrCategorias.length) {
                    this.setState({ cargando: true, bloquearBotones: true }, () => {
                        CategoriasRequest.ListarCategorias(true)
                            .then(response => {
                                state.arrCategorias = response.data;
                                return CatalogosRequest.ListarDiasPedido();
                            })
                            .then(response => {
                                state.arrDiasSemana = response.data
                                state.cargando = false;
                                state.bloquearBotones = false
                                this.setState(state)
                            })
                            .catch(err => {
                                openNotification(
                                    "Ha ocurrido un error al listar las categorías.",
                                    "Error al listar categorías",
                                    false
                                )
                            })
                    })
                }
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);
        this.setState({ bloquearBotones: false })
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    handleSubmit = () => {
        let state = { ...this.state }
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values.sitios = this.props.drives_selected
                this.setState({ cargando: true, bloquearBotones: true }, () => {
                    CategoriasRequest.CrearCategoriaCalendario(values)
                        .then(response => {
                            state.cargando = false
                            state.bloquearBotones = false
                            this.setState(state)
                            this.props.form.resetFields();
                            this.props.esconderModal(true);
                            openNotification(
                                "Se ha creado el registro correctamente.",
                                "Registro creado correctamente",
                                true
                            )
                        })
                        .catch(err => {
                            openNotification(
                                "Ha ocurrido un error al guardar el registro.",
                                "Error al guardar registro",
                                false
                            )
                        })
                })

            }
        })


    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal
                    title="Asignación de categoría y calendario"
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.handleSubmit}
                    width={this.state.isPos ? "85%" : "35%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-asignar-categoria-form"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-asignar-categoria-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.handleSubmit}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.handleSubmit}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label="Categoría"
                                        colon={true}>
                                        {getFieldDecorator('categorias', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione una categoría.' },
                                            ]
                                        })(
                                            <Select
                                                allowClear
                                                style={{ width: '100%' }}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                showSearch
                                                maxLength={100}
                                                showArrow
                                                id="select-elegir-categoria-asignacion-form"
                                                defaultActiveFirstOption={false}
                                                optionFilterProp="children"
                                                mode="multiple"
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrCategorias.length > 0 &&
                                                    this.state.arrCategorias.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label="Días de pedido"
                                        colon>
                                        {getFieldDecorator('dias_pedido', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione días de pedido.' },
                                            ]
                                        })(
                                            <Select
                                                allowClear
                                                style={{ width: '100%' }}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                showSearch
                                                maxLength={100}
                                                showArrow
                                                id="select-elegir-dias-asignacion-form"
                                                defaultActiveFirstOption={false}
                                                optionFilterProp="children"
                                                mode="multiple"
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrDiasSemana.length > 0 &&
                                                    this.state.arrDiasSemana.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormAsignacion);